/**
 * Get Axios from window and use it
 * @return {*}
 * @throws Error
 */
export const useAxios = () => {
    const axios = window.axios

    if (!axios) {
        throw new Error('Axios is not available')
    }

    return axios
}

/**
 * Get Axios with prefilled Sportnect API URL
 * @param {string} url - with leading slash, ex. /sport
 * @param {Object} data - request data
 * @param {string} type - type of request in lowercase, ex. get, post, put
 * @return {Promise}
 */
export const useSNAxios = (url, data, type = 'get') => {
    const axios = useAxios()

    return axios[type](`${window.APP_CONFIG.REACT_APP_API_URL}api${url}`, data)
}
